import React, { useEffect, useRef, useState } from "react";
import { Play, Pause, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// ~15s spoken intro in Uncle Danny's voice at the start of a chapter. Hidden until recorded.
export default function ChapterWelcome({ sectionId }) {
  const [w, setW] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [loading, setLoading] = useState(false);
  const audio = useRef(null);

  useEffect(() => {
    setW(null);
    api.get(`/site/chapter-intro/${sectionId}`).then((r) => setW(r.data)).catch(() => {});
  }, [sectionId]);

  if (!w?.available) return null;
  const toggle = () => {
    const a = audio.current;
    if (!a) return;
    if (a.paused) {
      setLoading(true);
      a.play().catch(() => { setLoading(false); toast.error("The intro couldn't play just now."); });
    }
    else a.pause();
  };
  const first = sectionId === "inner-child";

  return (
    <div className="mb-10 flex items-center gap-4 border-l-2 border-terracotta pl-4 py-1" data-testid="chapter-welcome">
      <button onClick={toggle} aria-label={playing ? "Pause intro" : "Play intro from Uncle Danny"} data-testid="chapter-welcome-play"
        className="h-11 w-11 shrink-0 rounded-full border border-terracotta text-terracotta hover:bg-terracotta hover:text-obsidian-900 flex items-center justify-center transition-colors">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4 ml-0.5" />}
      </button>
      <div>
        <p className="font-serif text-lg text-bone-100 leading-tight">{first ? "A welcome from Uncle Danny" : "A word from Uncle Danny"}</p>
        <p className="font-sans text-xs uppercase tracking-[0.2em] text-bone-500">15 seconds · before you begin</p>
      </div>
      <audio ref={audio} src={`${BACKEND}${w.audio_url}`} preload="none" onPlay={() => setPlaying(true)} onPlaying={() => setLoading(false)}
        onError={() => { setLoading(false); setPlaying(false); }}
        onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} data-testid="chapter-welcome-audio" />
    </div>
  );
}
